export default __webpack_public_path__ + "static/do-leading-visual-color-030a8d72b65d09c11a05e75b261d45a6.png";